import {AfterViewInit, Component, Input} from '@angular/core';
import {NotificationType} from "./notification-type";
import {NotificationData} from "./notification-data";

@Component({
  selector: 'brt-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements AfterViewInit{

  NotificationType = NotificationType;

  @Input("data") data!: NotificationData;

  isVisible = false;

  constructor() {
  }

  ngAfterViewInit() {
    window.requestAnimationFrame( () => {
      this.isVisible = true;
    });
  }
}
